import React, { useMemo } from "react";
import { HigherContrastToggleButtonGroup } from "./ResultsViewToggle";
import { Stack, ToggleButton, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useLanguage } from "./Language";
import { useBranchLimits } from "./BranchLimits";
import { ResourceDWR } from "../dto/ResourceDWR";

interface SelectedLocationsCopiesToggleProps {
  viewSelected: boolean;
  resource: ResourceDWR;
  includeTextualHoldings?: boolean;
  onChange: (viewSelected: boolean) => void;
}
export const SelectedLocationsCopiesToggle = ({
  viewSelected,
  resource,
  includeTextualHoldings = false,
  onChange,
}: SelectedLocationsCopiesToggleProps) => {
  const { translate } = useLanguage(); // TODO tokens
  const { displayInCopiesBranchIds, selectedBranchIds } = useBranchLimits();

  const isLimited = useMemo(() => {
    const allHoldings = includeTextualHoldings
      ? [...resource.holdingsInformations, ...resource.textualHoldings]
      : [...resource.holdingsInformations];
    //   ResourceDWR has no knowledge of location configuration limits
    const displayableHoldings = allHoldings.filter(({ branchIdentifier }) =>
      displayInCopiesBranchIds.includes(branchIdentifier)
    );
    const selectedHoldings = selectedBranchIds?.length
      ? displayableHoldings.filter(({ branchIdentifier }) =>
          selectedBranchIds.includes(branchIdentifier)
        )
      : [...displayableHoldings];
    return displayableHoldings?.length !== selectedHoldings?.length;
  }, [selectedBranchIds, displayInCopiesBranchIds, resource]);

  if (!isLimited) {
    return;
  }

  return (
    <HigherContrastToggleButtonGroup
      color="secondary"
      size="small"
      value={viewSelected}
      exclusive
      onChange={(_, value) => {
        if (value !== null) {
          onChange(value);
        }
      }}
    >
      <Tooltip title={translate("copiesAreLimited")}>
        <ToggleButton value={true}>
          <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
            {viewSelected === true && <CheckIcon />}
            {translate("availability_viewSelectedLocations")}
          </Stack>
        </ToggleButton>
      </Tooltip>
      <ToggleButton value={false}>
        <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
          {viewSelected === false && <CheckIcon />}
          {translate("availability_viewAllLocations")}
        </Stack>
      </ToggleButton>
    </HigherContrastToggleButtonGroup>
  );
};
